// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".settings-nav[data-v-71f3597a] {\n  width: 100%;\n  color: var(--portal-text);\n  text-align: left;\n}\n.settings-divider[data-v-71f3597a] {\n  height: 1px;\n  margin: 7px 4px;\n  background: var(--portal-border);\n}\n.settings-actions[data-v-71f3597a] {\n  display: grid;\n  gap: 2px;\n}", ""]);
// Exports
module.exports = exports;
